import { jsx } from 'react/jsx-runtime';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary.js';

function Body({ catchComponentError, children, onCatch }) {
    return (jsx("div", { className: "sidebar__body", children: catchComponentError
            ? (jsx(ErrorBoundary, { onCatch: onCatch, children: children }))
            : children }));
}
Body.defaultProps = {
    catchComponentError: true,
    children: null,
    onCatch: null,
};

export { Body as default };
